import React, { FC } from 'react'
import { Spacer } from 'components/Utility'

const BusinessHourHelp: FC = React.memo(() => {
  return (
    <div>
      <p>・sacri上の営業時間とは実際のお店の営業時間と異なります。</p>
      <p>
        ・お客さまがアプリ上で当日取り置きの商品をオーダー開始時刻からラストオーダー時刻の間で、注文することができます。
      </p>
      <Spacer size={16} />
      <p>予めご理解いただきますようよろしくお願いいたします。</p>
    </div>
  )
})

export default BusinessHourHelp
